import { OneTrustService } from '@altack/ngx-onetrust';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OneTrustInitService {
  constructor(private oneTrust: OneTrustService) {}

  public load(): void {
    return this.oneTrust.loadOneTrust();
  }
}
